import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types"
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {
    enviarOrCompletarFlujoDocumentoEmpleadoAPI,
    getDataFromFlujoDocumentoEmpleadoAPI, getDataToCreateFlujoDocumentoEmpleadoAPI,
    aprobarFlujoDocumentoEmpleadoAPI,
} from "../../../../consumers/backendApisUrls";
import SpinnerLoading from "../../../../components/pageComponents/SpinnerLoading";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import FlujoDocumentoEmpleado from "./FlujoDocumentoEmpleado";
import {isNullOrUndefinded} from "../../../../helper/utils";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import {toast} from "react-toastify";
import ModalEnabled from "../../../../components/modalComponents/ModalEnabled";

export const KEYS = {
    NombreActividad: "NombreActividad",
    NombreFlujoDocumento: "NombreFlujoDocumento",
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    Instrucciones: "Instrucciones",
    ProcedimientoUrl: "ProcedimientoUrl",
    DocumentoGenericoUrl: "DocumentoGenericoUrl",
    FlujoDocumentoEmpleadoArchivoFileViewModel: "FlujoDocumentoEmpleadoArchivoFileViewModel",
    FlujoDocumentoEmpleadoArchivoUrl: "FlujoDocumentoEmpleadoArchivoUrl",
    Empleado: "Empleado",
    Cargo: "Cargo",
    Sede: "Sede",
    Paso: "Paso",
    Responsable: "Responsable",
    EstadoPaso: "EstadoPaso"

};

const SECTION_NAME = "DetalleFlujoDocumentoEmpleado";

const DetalleFlujoDocumentoEmpleado = ({toggleModal, manageSearch, row, fromAdminPage}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [submitForm] = useSubmitForm();
    const [formValues, setFormValues] = useState({});
    const [modalDataToCreate, setModalDataToCreate] = useState({});
    const [modalDataAlreadyCreated, setModalDataAlreadyCreated] = useState({});
    const [executeMangGet] = useManageGetRequest();

    const [modalEnabled, setModalEnabled] = useState({ isEnable: false, component: React.Fragment });




    const getDataToCreateForModal = async () => {
        const api = getDataToCreateFlujoDocumentoEmpleadoAPI(row?.IdFlujoDocumento);
        await executeMangGet(api, ({ data }) => getDataToCreateForModalCallBack(data), false);
    }

    const getDataToCreateForModalCallBack = async (data) => {
        setModalDataToCreate(data)
        if (!isNullOrUndefinded(data?.Message)){
            toast.error(data?.Message);
        }
    };

    const getDataFromFlujoDocumentoEmpleadoForModal = async () => {
        if (row?.IdFlujoDocumentoEmpleado){
            const api = getDataFromFlujoDocumentoEmpleadoAPI(row?.IdFlujoDocumentoEmpleado);
            await executeMangGet(api, ({ data }) => getDataFromFlujoDocumentoEmpleadoAPIlCallBack(data), false);
        }
    }

    const getDataFromFlujoDocumentoEmpleadoAPIlCallBack = async (data) => {
        setModalDataAlreadyCreated(data)
        if (!isNullOrUndefinded(data?.Message)){
            toast.error(data?.Message);
        }
    };


    const handleEnviar = async (e) => {
        if (e)
            e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = enviarOrCompletarFlujoDocumentoEmpleadoAPI();
        payload = getPayload();
        keys = KEYS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitAPICallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleAprobar = async (e) => {
        if (e)
            e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = aprobarFlujoDocumentoEmpleadoAPI(row?.IdFlujoDocumentoEmpleado);
        payload = {}
        keys = KEYS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitAPICallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const getPayload = () => {
        return {
            IdFlujoDocumentoEmpleado: row?.IdFlujoDocumentoEmpleado,
            IdFlujoDocumento: row.IdFlujoDocumento,
            IdEmpleado: row.IdEmpleado,
            ...formValues,
        }
    }

    const successSubmitAPICallback = async ({data}) => {
        toggleModal();
        manageSearch();
    }

    const init = async () => {
        getInitData();

    };

    const getInitData = async () => {
        getDataToCreateForModal();
        getDataFromFlujoDocumentoEmpleadoForModal();
    }

    useEffect(() => {
        init();
    }, []);

    if (isLoading) return <SpinnerLoading/>
    {/* modalDataAlreadyCreated[KEYS.FlujoDocumentoEmpleadoArchivoUrl] === "" || isNullOrUndefinded(modalDataAlreadyCreated[KEYS.FlujoDocumentoEmpleadoArchivoUrl])*/}

    return (<>
            <ModalEnabled modalEnabled={modalEnabled} setModalEnabled={setModalEnabled} refreshPage={manageSearch} />

            <ModalForm
                titulo="Documento"
                width="1100px"
                showModal={toggleModal}
                isSubmitting={isSubmitting}
                saveButtonDisabled={isUploading || isSubmitting}
                hasSaveButton={false}>
                <div className="displayFlexWrap">
                    <FlujoDocumentoEmpleado
                        SECTION_NAME={SECTION_NAME}
                        idEmpleado={formValues?.IdEmpleado}
                        formValues={formValues}
                        setFormValues={setFormValues}
                        KEYS={KEYS}
                        row={row}
                        modalDataToCreate={modalDataToCreate}
                        modalDataAlreadyCreated={modalDataAlreadyCreated}
                        handleEnviar={handleEnviar}
                        handleAprobar={handleAprobar}
                        toggleMainModal={toggleModal}
                        setModalEnabled={setModalEnabled}
                        fromAdminPage={fromAdminPage}
                    />
                </div>
            </ModalForm>
    </>

    );
}

DetalleFlujoDocumentoEmpleado.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default DetalleFlujoDocumentoEmpleado;